import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=6077c4be&scoped=true&"
import script from "./Packaging.vue?vue&type=script&lang=js&"
export * from "./Packaging.vue?vue&type=script&lang=js&"
import style0 from "./Packaging.vue?vue&type=style&index=0&id=6077c4be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077c4be",
  null
  
)

export default component.exports